import { defineMessages } from 'react-intl';

export default defineMessages({
  transactionContactStep: {
    id: 'transaction.contact_step.title',
  },
  transactionContactSubTitle: {
    id: 'transaction.contact_step.sub_title',
  },
  successAddContact: {
    id: 'transaction.success_add_contact_transaction',
  },
  confirm: {
    id: 'court_manager_legal_proceedings_page.procedure_decision.validate',
  },
  assignExpertButtonTitle: {
    id: 'transaction.assign_expert.button.title',
  },
  updateTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.edit',
  },
  missionAccordionTitle: {
    id: 'transaction.mission.accordion_title',
  },
  expert: {
    id: 'expertise.recap_drawer.expert',
  },
  expertiseNature: {
    id: 'expertise.recap_drawer.expertiseNature',
  },
  missionDate: {
    id: 'expertise.table_header_titles.missionDate',
  },
  rejectionReason: {
    id:
      'court_manager_legal_proceedings_page.judgement_add_document.rejection.reason',
  },
  addJudiciaryButtonTitle: {
    id: 'transaction.recap_contact.add_expert_judiciary.title',
  },
  reasonInputTitle: {
    id: 'transaction.contact.reason_input.title',
  },
  cancel: {
    id: 'cancel_btn',
  },
  importMissionDialogTitle: {
    id: 'transaction.imported_mission.dialog.title',
  },
  accordionTitle: {
    id: 'expert_expertise.tab_consulting_report.title',
  },
  successImportTitle: {
    id: 'transaction.imported_mission.success.title',
  },
  accordionJudiciaryReportTitle: {
    id: 'expert_expertise.tab_judiciary_report.title',
  },
  generateAssignementLetter: {
    id: 'transaction.generate_assignement_letter.title',
  },
  ExpertDate: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.expert_fields.date',
  },
  expertConseilField: {
    id: 'Assign.expert_drawer.Expert_conseil',
  },
  expertNature: {
    id: 'expertise.nature.title',
  },
  medicalExpertise: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.medicalExpertise',
  },
  accountingExpertise: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.accountingExpertise',
  },
  opposingLawyer: {
    id: 'legal-proceedings.risk.information.opposing_lawyer',
  },
  opposingLawyerCity: {
    id: 'legal-proceedings.risk.information.opposing_lawyer_city',
  },
  opposingLawyerAddress: {
    id: 'legal-proceedings.risk.information.opposing_lawyer_address',
  },
  opposingLawyerEmail: {
    id: 'legal-proceedings.risk.information.opposing_lawyer_email',
  },
  missionExpertiseDateError: {
    id: 'mission.expertise_date.error',
  },
  invalidDate: {
    id: 'preopening_page.invalid_date',
  },
  typeTitle: {
    id: 'transaction.second_examination.type.title',
  },
  secondExaminationTitle: {
    id: 'transaction.second_examination.title',
  },
  ExpertDrawerTitle: {
    id: 'Assign.expert_drawer.title',
  },
});
